import { AmazonPayState } from '../types/AmazonPayState'
import { GetterTree } from 'vuex';

export const getters: GetterTree<AmazonPayState, any> = {}